import Init from '../../../extendable/Init';

import './Login.scss';

const Login = () => {
};

Init(Login);
